/** Supported display currencies for Premium pricing. */
export const SUPPORTED_CURRENCIES = ['USD', 'EUR', 'GBP'];

const GBP_REGIONS = new Set(['GB', 'GG', 'IM', 'JE']);
const EUROZONE_REGIONS = new Set([
  'AT', 'BE', 'HR', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT',
  'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'SK', 'SI', 'ES',
  // Microstates using the euro
  'AD', 'MC', 'SM', 'VA',
]);

/**
 * Best-guess display currency from the browser locale (e.g. en-GB → GBP,
 * de-DE → EUR, en-US → USD). Falls back to USD when the locale is missing
 * or unrecognised. Display only — the Stripe price determines the charge.
 */
export function detectCurrency() {
  try {
    const language = typeof navigator !== 'undefined' ? navigator.language : '';
    if (!language) return 'USD';
    const region = new Intl.Locale(language).maximize().region;
    if (GBP_REGIONS.has(region)) return 'GBP';
    if (EUROZONE_REGIONS.has(region)) return 'EUR';
    return 'USD';
  } catch {
    return 'USD';
  }
}
